/**
 * Nav Data — Macluumaadka Navbar-ka
 *
 * Halkan ka badal links-ka navigation-ka
 */

/* Desktop + mobile nav links — id-ka waa section-ka uu ku scroll-gareynayo */
export const navLinks = [
  { label: "Adeegyada", id: "features" },
  { label: "Sida uu u shaqeeyo", id: "how" },
  { label: "Masharic", id: "projects" },
];
